 import React from 'react';
import {Route, DefaultRoute, NotFoundRoute} from 'react-router';

import Wrapper from './views/Wrapper';
import AppTemplate from './views/AppTemplate';
import ProTemplate from './views/ProTemplate';
import BsnTemplate from './views/BsnTemplate';
import CleanTemplate from './views/CleanTemplate';

import LoginView from './views/LoginView';
import SignupView from './views/SignupView';
import ForgotPasswordView from './views/ForgotPasswordView';
import ResetPasswordView from './views/ResetPasswordView';
import NotFound from './views/NotFound';
import DashboardWelcome from './views/DashboardWelcome';
import DashboardOverview from './views/DashboardOverview';
import DashboardOverview2 from './views/DashboardOverview2';
import CreateShift from './views/CreateShift';
import CreateShiftCompleted from './views/CreateShiftCompleted';
import EditShift from './views/EditShift';
import Settings from './views/Settings';
import Shift from './views/Shift';
import FinishShift from './views/FinishShift';
import FinishShiftCompleted from './views/FinishShiftCompleted';
import CompleteProfile from './views/CompleteProfile';
import CompleteProfileCompleted from './views/CompleteProfileCompleted';
import DashboardProOffers from './views/DashboardProOffers';
import MyShifts from './views/MyShifts';

import {anonymousView, authenticatedView, appView} from './utils/authViewHelpers';


if (process.env.BROWSER && process.env.NODE_ENV !== 'production') {
    // Note: Add stylesheets inside the following files:
    require('./styles/vendor');
    require('./styles/main');
}


const routes = (
    <Route name='root' path='/' handler={Wrapper}>

        <Route handler={CleanTemplate}>
            <Route name='login' path='/login/?:token?/' handler={anonymousView('agenda')(LoginView)} />
            <Route name='signup' path='/signup/' handler={anonymousView('agenda')(SignupView)} />
            <Route name='forgotpassword' path='/forgot/' handler={anonymousView('agenda')(ForgotPasswordView)} />
            <Route name='resetpassword' path='/reset_password/:token/' handler={anonymousView('agenda')(ResetPasswordView)} />

            <DefaultRoute name='/login' handler={anonymousView('agenda')(LoginView)} />
        </Route>

        <Route handler={authenticatedView('login')(AppTemplate)}>
            <Route handler={appView('isPro', 'agenda')(ProTemplate)}>
                <Route name='completeprofile' path='/complete_profile/' handler={CompleteProfile} />
                <Route name='completeprofilecompleted' path='/complete_profile_completed/' handler={CompleteProfileCompleted} />
                <Route name='offers' path='/offers/' handler={DashboardProOffers} />
                <Route name='myshifts' path='/myshifts/' handler={MyShifts} />
                <Route name='prosettings' path='/mysettings/' handler={Settings}>
                    <Route name='prosettingstab' path='/mysettings/:selectedTab/' handler={Settings} />
                </Route>
            </Route>
            <Route handler={appView('isBsn', 'offers')(BsnTemplate)}>
                <Route name='welcome' path='/dashboard/welcome/' handler={DashboardWelcome} />
                <Route name='agenda' path='/dashboard/' handler={DashboardOverview} />
                <Route name='week' path='/dashboard/week/' handler={DashboardOverview2} />
                <Route name='createshift' path='/create_shift/' handler={CreateShift} />
                <Route name='shiftcompleted' path='/shift_completed/:shiftId/' handler={CreateShiftCompleted} />
                <Route name='editshift' path='/edit_shift/:shiftId/' handler={EditShift} />
                <Route name='settings' path='/settings/' handler={Settings}>
                    <Route name='settingstab' path='/settings/:selectedTab/' handler={Settings} />
                </Route>
                <Route name='shift' path='/shift/:shiftId/' handler={Shift} />
                <Route name='finish_shift' path='/finish_shift/:shiftId/' handler={FinishShift} />
                <Route name='shiftclosed' path='/shift_closed/:shiftId/' handler={FinishShiftCompleted} />
            </Route>
        </Route>

        <NotFoundRoute handler={NotFound} />
    </Route>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./app/src/routes.js
 **/